var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _g3, _path13, _g4, _path14, _g5, _path15, _path16, _path17, _path18, _path19, _g6, _path20, _path21, _path22, _g7, _g8, _path23, _path24, _g9, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountstorage = function SvgAccountstorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299,
    height: 201
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accountstorage_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6070",
    fill: "none",
    stroke: "#cdceed",
    d: "M0 0h14v11.636H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "accountstorage_svg__a",
    x: 92,
    y: 86,
    width: 130,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0e133b",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25714",
    d: "M46.864 94.211c28.864-1.552 40.968-22.967 58.969-25.76s29.989 7.428 31.9 17.933",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#accountstorage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25701",
    d: "M113 95h82a12 12 0 0 1 12 12v67a12 12 0 0 1-12 12h-82a12 12 0 0 1-12-12v-67a12 12 0 0 1 12-12",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25702",
    d: "M199.52 177.144h-9.7a.82.82 0 0 1-.82-.82v-2.71a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25703",
    d: "M199.52 169.484h-9.7a.82.82 0 0 1-.82-.82v-2.71a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25704",
    d: "M199.52 161.824h-9.7A.82.82 0 0 1 189 161v-2.71a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82V161a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25705",
    d: "M199.52 154.164h-9.7a.82.82 0 0 1-.82-.819v-2.71a.82.82 0 0 1 .82-.82h9.7a.819.819 0 0 1 .82.82v2.71a.819.819 0 0 1-.82.819",
    fill: "#81e6d9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25706",
    d: "M199.52 146.505h-9.7a.82.82 0 0 1-.82-.82v-2.71a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25707",
    d: "M199.52 138.845h-9.7a.82.82 0 0 1-.82-.82v-2.71a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25708",
    d: "M199.52 131.186h-9.7a.82.82 0 0 1-.82-.82v-2.71a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25709",
    d: "M199.52 123.526h-9.7a.82.82 0 0 1-.82-.82V120a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#81e6d9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25711",
    d: "M199.52 115.867h-9.7a.82.82 0 0 1-.82-.82v-2.706a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#e2e8f0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25712",
    d: "M199.52 108.207h-9.7a.82.82 0 0 1-.82-.82v-2.706a.82.82 0 0 1 .82-.82h9.7a.82.82 0 0 1 .82.82v2.71a.82.82 0 0 1-.82.82",
    fill: "#e2e8f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25710",
    d: "M182.336 103.5v73.287",
    fill: "none",
    stroke: "#e2e8f0",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6069",
    fill: "none",
    d: "M101 95h106v91H101z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12089",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    d: "m124.12 127.865 19.88-7.787"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25675",
    d: "M163.875 127.865 144 120.078v15.574"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25676",
    d: "M144 135.652v25.271l-19.88-7.788v-11.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25677",
    d: "m138.047 147.089-19.879-7.787 5.952-11.437 19.88 7.787Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25678",
    d: "m149.952 147.089 19.88-7.787-5.957-11.437-19.88 7.787Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25679",
    d: "m144 160.922 19.875-7.787v-11.5"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M45 79.999a20 20 0 1 1-20 20 20 20 0 0 1 20-20",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12077",
    transform: "translate(-1546 4263)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 4.957,
    cy: 4.957,
    r: 4.957,
    transform: "translate(1584.297 -4172.753)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M1593.977-4160.767a6.1 6.1 0 0 0-4.724-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M1583.065-4156.98a6.028 6.028 0 0 1 6.19-5.86m9.163 2.071v7.035m3.515-3.518h-7.03"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M157.5 0a20 20 0 1 1-20 20 20 20 0 0 1 20-20",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12079",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    transform: "translate(-1571 4259)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 4.957,
    cy: 4.957,
    r: 4.957,
    transform: "translate(1721.797 -4248.753)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M1731.477-4236.766a6.1 6.1 0 0 0-4.724-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M1720.565-4232.98a6.028 6.028 0 0 1 6.19-5.86m9.163 2.071v7.035m3.515-3.518h-7.03"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M68.5 16a20 20 0 1 1-20 20 20 20 0 0 1 20-20",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12078",
    transform: "translate(-1561 4258)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 4.957,
    cy: 4.957,
    r: 4.957,
    transform: "translate(1622.797 -4231.753)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M1632.477-4219.766a6.1 6.1 0 0 0-4.724-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M1621.565-4215.98a6.028 6.028 0 0 1 6.19-5.86m9.163 2.071v7.035m3.515-3.518h-7.03"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25722",
    d: "M57.754 126.072a11.682 11.682 0 1 1-11.682 11.682 11.682 11.682 0 0 1 11.682-11.682",
    fill: "#dee0f8",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25728",
    d: "M111.105 48.017a4.082 4.082 0 1 1-4.082 4.082 4.082 4.082 0 0 1 4.082-4.082",
    fill: "#dee0f8",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25722",
    d: "M190.322 39.001a8 8 0 1 1-8 8 8 8 0 0 1 8-8M251 144.065a7.935 7.935 0 1 1-7.935 7.935 7.935 7.935 0 0 1 7.935-7.935",
    fill: "#dee0f8",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25729",
    d: "M225.845 111.517a4.091 4.091 0 1 1-4.091 4.091 4.091 4.091 0 0 1 4.091-4.091",
    fill: "#dee0f8",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M251 14.999a20 20 0 1 1-20 20 20 20 0 0 1 20-20",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12080",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    transform: "translate(-1571 4259)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 4.957,
    cy: 4.957,
    r: 4.957,
    transform: "translate(1815.297 -4233.753)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M1824.977-4221.767a6.1 6.1 0 0 0-4.724-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M1814.065-4217.98a6.028 6.028 0 0 1 6.19-5.86m9.163 2.071v7.035m3.515-3.518h-7.03"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25713",
    d: "M245.846 52.375c-3.631 18.963-18.753 30.278-35.7 37.944",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25715",
    d: "M257.582 92.58c-14.508-19.1-56.467-37.543-68.261-9.921",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25716",
    d: "M70.526 52.1c-.184 17.263 16.335 30.751 31.989 39.144",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12074"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12073",
    transform: "translate(108.188 104)",
    clipPath: "url(#accountstorage_svg__b)",
    fill: "none",
    stroke: "#cdceed",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25717",
    d: "M2.082 4.694a5.169 5.169 0 0 1 9.766-.982",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25718",
    d: "M12.17 6.963a5.17 5.17 0 0 1-9.762.961",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25719",
    d: "m9.98 7.48 2.271-.61 1.1 2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25720",
    d: "m3.914 4.335-2.051.687L.65 3.241",
    strokeLinejoin: "round"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12075",
    fill: "none",
    stroke: "#cdceed",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 227",
    d: "M165.576 176.595v-1.748"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 228",
    d: "M167.844 176.595v-3.496"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 229",
    d: "M170.111 176.594v-5.077"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 230",
    d: "M172.378 176.595v-8.142"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 231",
    d: "M174.646 176.594v-5.796"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25721",
    d: "M162.27 36.744c8.606 22.789 3.622 32.945-2.123 47.156",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M266 82.999a20 20 0 1 1-20 20 20 20 0 0 1 20-20",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12081",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    transform: "translate(-1571 4259)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 4.957,
    cy: 4.957,
    r: 4.957,
    transform: "translate(1830.297 -4165.753)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M1839.977-4153.767a6.1 6.1 0 0 0-4.724-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M1829.065-4149.98a6.028 6.028 0 0 1 6.19-5.86m9.163 2.071v7.035m3.515-3.518h-7.03"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25723",
    d: "m95.45 92.8 7.682-1.259-.949-7.753",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25724",
    d: "m131.45 82.683 6.677 3.968 3.422-5.812",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4999850000000001
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25725",
    d: "m156.341 77.656 3.591 6.449 6.81-4.15",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4999850000000001
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25726",
    d: "m186.909 75.392 2.081 7.34 6.55-3.412",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.49982
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25727",
    d: "m212.101 83.336-2.638 7.608 8.45.371",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.49982
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7965",
    fill: "none",
    d: "M0 0h299v200H0z"
  })));
};
export default SvgAccountstorage;